export const genAdjustAmountColumns = () => [
  { label: '调整项目', prop: 'name' },
  { label: '调整金额', prop: 'amount' },
  { label: '实际调整金额', prop: 'real', vslot: 'real' },
  { label: '当期调整欠款余额', prop: 'history' },
]

export const SETTLE_PROCESS = {
  GIVEUP: '30', // 放弃结算
  CANCEL: '40', // 取消结算
  STOP: '50', // 暂停结算
}

export const APPEAL_STATUS = {
  UNAPPEAL: 0, // 未申诉
  APPEALING: 1, // 申诉中
  APPEAL_PASS: 2, // 申诉通过
  APPEAL_REJECT: 3, // 申诉驳回
  APPEAL_WITHDRAW: 4, // 申诉撤回
}

export const stateTypeList = {
  // 单车
  bikeStateTypeList: [
    {
      value: 14,
      label: '待确认',
    },
    {
      value: 15,
      label: '已确认',
    },
    {
      value: 50,
      label: '账单审核中',
    },
    {
      value: 60,
      label: '发票录入/验票',
    },
    {
      value: 70,
      label: '待付款',
    },
    {
      value: 80,
      label: '已完成',
    },
  ],

  // 电单车
  eBikeStateTypeList: [
    {
      value: 10,
      label: '待结费配置',
    },
    {
      value: 20,
      label: '待财务结算组确认',
    },
    {
      value: 30,
      label: '待合作商确认',
    },
    {
      value: 40,
      label: '账单待提交',
    },
    {
      value: 50,
      label: '账单审核中',
    },
    {
      value: 60,
      label: '发票录入&验票',
    },
    {
      value: 70,
      label: '付款中',
    },
    {
      value: 80,
      label: '已完成',
    },
    {
      value: 100,
      label: '已关闭',
    },
  ],

  bikeTypeList: [
    {
      label: '单车校园-收入分成',
      value: 52,
    },
    {
      label: '单车校园-固定管理费',
      value: 51,
    },
    {
      label: '单车-代理合作商分成',
      value: 6,
    },
    {
      label: '单车-联营合作商分成',
      value: 5,
    },
    {
      label: '单车-经营咨询合作商分成',
      value: 4,
    },
  ],

  eBikeTypeList: [
    {
      label: '代理商分成',
      value: 0,
    },
    {
      label: '联营商分成',
      value: 1,
    },
    {
      label: '合伙人分成',
      value: 2,
    },
  ],
}

// 分成方案
export const PLAN_TYPE = {
  STANDARD: 0, // 标准方案
  SPECIAL: 1, // 特殊方案
  XYZ: 2, // XYZ方案
  COMPLIANCE: 3, // 合规运营分成
}

// 合作商承担费用
export const feeAccountFeeColumns = [
  {
    label: '费用类型',
    prop: 'itemName',
  },
  {
    label: '本期调整金额',
    prop: 'nowAmount',
  },
  {
    label: '历史调整欠款金额',
    prop: 'historyAmount',
  },
  {
    label: '调整金额',
    prop: 'amount',
  },
  {
    label: '实际调整金额',
    prop: 'realAmount',
  },
  {
    label: '当期调整余额',
    prop: 'thisAmount',
  },
]
export const feeAccountFeeKeyNames = [
  {
    itemId: 'deducteBikeResultAmount',
    itemName: '合作商承担取扣车费用',
  },
  {
    itemId: 'commonService',
    itemName: '公共服务咨询费',
  },
  {
    itemId: 'bikeMoney',
    itemName: '摆车费用（三方摆车）',
  },
  {
    itemId: 'otherMoney',
    itemName: '其他金额',
  },
]

// XYZ/标准/特殊方案分成比例
export const feeRateColumns = [
  {
    label: 'X固定分成比例',
    prop: 'xRate',
  },
  {
    label: 'X固定分成金额',
    prop: 'xFee',
  },
  {
    label: 'Y考核分成比例',
    prop: 'yRate',
  },
  {
    label: 'Y最终系数',
    prop: 'ratioY',
  },
  {
    label: 'Z考核分成比例',
    prop: 'zRate',
  },
  {
    label: 'Z考核分成系数',
    prop: 'ratioZ',
  },
  {
    label: 'Y扣减系数',
    prop: 'yDeductRatio',
  },
  {
    label: 'Y扣减金额总和',
    prop: 'yDeductFee',
  },
  {
    label: 'Z扣减系数',
    prop: 'zDeductRatio',
  },
  {
    label: 'Z扣减金额',
    prop: 'zDeductFee',
  },
]

// 合规运营分成方案分成比例
export const feeComplianceRateColumns = [
  {
    label: 'X固定分成比例',
    prop: 'xRate',
  },
  {
    label: 'X固定分成金额',
    prop: 'xFee',
  },
  {
    label: 'Y考核分成比例',
    prop: 'yRate',
  },
  {
    label: 'Y最终系数',
    prop: 'ratioY',
  },
  {
    label: 'Y考核分成金额',
    prop: 'yFee',
  },
  {
    label: 'Y绩效目标考核系数',
    prop: 'yPerformanceRatio',
  },
  {
    label: 'Y扣车扣减系数',
    prop: 'yBikeDeductRatio',
  },
  {
    label: 'Y竞对超投扣减系数',
    prop: 'ySuperDeductRatio',
  },
  {
    label: 'Y配额下降扣减系数',
    prop: 'yQuotaDeductRatio',
  },
  {
    label: 'Y扣减系数',
    prop: 'yDeductRatio',
  },
  {
    label: 'Y扣减金额总和',
    prop: 'yDeductFee',
  },
]
